import type { PayloadAction, Update } from '@reduxjs/toolkit'
import { createEntityAdapter, createSlice } from '@reduxjs/toolkit'

import type { CubeLineInfos } from '../../types'

export const cubesAdapter = createEntityAdapter<CubeLineInfos>({
  selectId: cube => cube.id,
})

export const cubeSlice = createSlice({
  name: 'cubes',
  initialState: cubesAdapter.getInitialState(),
  reducers: {
    addCubes(state, action: PayloadAction<CubeLineInfos[]>) {
      cubesAdapter.upsertMany(state, action.payload)
    },
    addLinesToCube(state, action: PayloadAction<Update<CubeLineInfos>>) {
      cubesAdapter.updateOne(state, action.payload)
    },
  },
})

export default cubeSlice.reducer
